/**
 * 第一个字符大写
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * 时间转换
 * 2020-10-24T13:26:11.000+0000 => 2020-10-24 21:26:11
 * @param {String} dateTime
 */
export function renderDateTime(date) {
  let dateTime = new Date(date).toJSON();
  return new Date(+new Date(dateTime) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
}


/**
 * 美食分类
 * @param {String,number} type
 */

export function foodType(type) {
  let list = [{ "name": "火锅", "type": "1" }, { "name": "串串", "type": "2" }, { "name": "川菜", "type": "3" }, { "name": "东北菜", "type": "4" }, { "name": "烤肉", "type": "5" }, { "name": "西餐", "type": "6" }, { "name": "日本菜", "type": "7" }, { "name": "面食", "type": "8" }, { "name": "小吃快餐", "type": "9" }, { "name": "酒吧", "type": "10" }, { "name": "咖啡厅", "type": "11" }, { "name": "自助餐", "type": "12" }, { "name": "面包甜品", "type": "13" }, { "name": "茶馆", "type": "14" }, { "name": "家常菜", "type": "15" }]
  let text = "暂无";
  list.forEach((item => {
    if (item.type == type) text = item.name;
  }))
  return text;
}

/**
 * 组局分类
 * @param {String,number} type
 */

export function planType(type) {
  let list = [{ "name": "火锅", "type": "1" }, { "name": "串串", "type": "2" }, { "name": "川菜", "type": "3" }, { "name": "东北菜", "type": "4" }, { "name": "烤肉", "type": "5" }, { "name": "西餐", "type": "6" }, { "name": "日本菜", "type": "7" }, { "name": "面食", "type": "8" }, { "name": "小吃快餐", "type": "9" }, { "name": "酒吧", "type": "10" }, { "name": "咖啡厅", "type": "11" }, { "name": "自助餐", "type": "12" }, { "name": "面包甜品", "type": "13" }, { "name": "茶馆", "type": "14" }, { "name": "家常菜", "type": "15" }]
  let text = "暂无";
  list.forEach((item => {
    if (item.type == type) text = item.name;
  }))
  return text;
}
